import React from "react";
import { $t } from "~/i18n.js";
import { AuthorisationStatus } from "./AuthorisationStatus.jsx";

export const getAuthorizationColumn = ({
  getPilotName = (d) => d.vlieger?.name,
  getAuthorisation = (d) => d.authorised,
}) => {
  return {
    title: $t("Authorisatie"),
    dataIndex: "authorised",
    sorter: (a, b) => {
      const aAuth = a.authorised;
      const bAuth = b.authorised;
      if (!aAuth && !bAuth) return 0;
      if (!aAuth) return 1;
      if (!bAuth) return -1;
      return 0;
    },
    render: (text, d) => {
      const authorised = text || getAuthorisation(d);
      if (!authorised) return null;
      return (
        <AuthorisationStatus
          authorisation={authorised}
          pilotName={getPilotName(d)}
        />
      );
    },
  };
};
